import { i18n } from '@/main.js'

export default {
    getRules: (state) => {
        console.log(state.rules[i18n.locale]);
        return state.rules[i18n.locale] ?  state.rules[i18n.locale] : [];
    },
    getLoadingRules: (state) => {
        return state.loadingRules;
    }
}